// Define the localization/content object
const courses = {
  seo: {
    title: 'Courses - SAI Academic Confucius Institute',
    description: 'Explore our comprehensive Chinese language courses from beginner to advanced levels. HSK courses, Business Chinese, and more with expert instructors and certified credentials.',
    keywords: 'Chinese language courses, HSK, Confucius Institute, learn Chinese, online courses, HSK certification, Business Chinese'
  },
  breadcrumb: {
    home: 'Home',
    courses: 'Courses'
  },
  hero: {
    title: 'Our Courses',
    subtitle: 'Discover a wide range of Chinese language courses designed for all levels',
    coursesCount: 'Courses',
    expertInstructors: 'Expert Instructors',
    certification: 'Certified Credentials'
  },
  stats: {
    totalCourses: 'Courses Available',
    totalStudents: 'Students Enrolled',
    averageRating: 'Average Rating',
    yearsExperience: 'Years Experience',
    certifiedInstructors: 'Certified Instructors'
  },
  filters: {
    searchPlaceholder: 'Search for a course...',
    level: 'Level',
    category: 'Category',
    mode: 'Study Mode',
    allLevels: 'All Levels',
    allCategories: 'All Categories',
    allModes: 'All Modes',
    resultsFound: 'results',
    clearAll: 'Clear All',
    gridView: 'Grid View',
    listView: 'List View',
    priceRanges: {
      all: 'All Prices',
      free: 'Free',
      under500: 'Under $500',
      '500to1000': '$500 - $1000',
      over1000: 'Over $1000'
    },
    ratings: {
      all: 'All Ratings',
      '4plus': '4+ Stars',
      '4.5plus': '4.5+ Stars'
    },
    durations: {
      all: 'All Durations',
      short: 'Short (≤8 weeks)',
      medium: 'Medium (9-16 weeks)',
      long: 'Long (17+ weeks)'
    },
    sortBy: {
      popularity: 'Most Popular',
      rating: 'Highest Rated',
      priceLowToHigh: 'Price: Low to High',
      priceHighToLow: 'Price: High to Low',
      newest: 'Newest'
    }
  },
  levels: {
    beginner: 'Beginner',
    elementary: 'Elementary',
    intermediate: 'Intermediate',
    advanced: 'Advanced',
    professional: 'Professional'
  },
  categories: {
    hsk: 'HSK',
    business: 'Business',
    yct: 'YCT',
    conversation: 'Conversation',
    culture: 'Culture'
  },
  modes: {
    online: 'Online',
    offline: 'In-Person',
    hybrid: 'Hybrid'
  },
  meta: {
    weeks: 'weeks',
    hours: 'hours',
    perSemester: 'per semester',
    duration: 'Duration',
    level: 'Level',
    mode: 'Study Mode',
    language: 'Language',
    certificate: 'Certificate'
  },
  cta: {
    viewCourse: 'View Course',
    contactUs: 'Contact Us',
    whatsapp: 'WhatsApp',
    title: 'Ready to Start Your Journey?',
    subtitle: 'Join thousands of students learning Chinese with us'
  },
  noResults: {
    title: 'No Results Found',
    message: 'Try changing your search criteria or filters'
  },

  // Comparison Feature
  comparison: {
    compare: 'Compare',
    addToCompare: 'Add to Compare',
    removeFromCompare: 'Remove from Compare',
    compareCourses: 'Compare Courses',
    compareNow: 'Compare Now',
    selected: 'Selected',
    clearAll: 'Clear All',
    title: 'Course Comparison',
    subtitle: 'Compare different courses to choose the best one for you',
    feature: 'Feature',
    image: 'Image',
    courseName: 'Course Name',
    price: 'Price',
    duration: 'Duration',
    level: 'Level',
    rating: 'Rating',
    students: 'Students',
    studyMode: 'Study Mode',
    certification: 'Certification',
    instructor: 'Instructor',
    modules: 'Modules',
    startDate: 'Start Date',
    location: 'Location',
    action: 'Action',
    viewCourse: 'View Course',
    remove: 'Remove',
    close: 'Close',
    bestPrice: 'Best Price',
    highestRated: 'Highest Rated',
    maxCoursesReached: 'You can compare up to 3 courses',
    selectCoursesToCompare: 'Select at least 2 courses to compare'
  },

  // Course Detail Page
  courseOverview: 'Course Overview',
  learningOutcomes: 'Learning Outcomes',
  courseBenefits: 'Course Benefits',
  courseCurriculum: 'Course Curriculum',
  curriculumDescription: 'A comprehensive and structured curriculum covering all aspects of Chinese language',
  lessons: 'Lessons',
  targetAudience: 'Target Audience',
  targetAudienceDescription: 'This course is specifically designed for',
  certification: 'Certification',
  certificationNote: 'You will receive an accredited certificate upon successful completion of the course',
  courseInstructor: 'Course Instructor',
  credentials: 'Credentials',
  biography: 'Biography',
  yearsExp: 'Years Experience',
  faq: 'Frequently Asked Questions',
  faqDescription: 'Answers to the most common questions about the course',
  stillHaveQuestions: 'Still have questions?',
  contactUsForMore: 'Contact us for more information',
  relatedCourses: 'Related Courses',
  relatedCoursesDescription: 'Other courses you might be interested in',
  viewAllCourses: 'View All Courses',

  // Course Details Sidebar
  courseDetails: 'Course Details',
  coursePrice: 'Course Price',
  specialOffer: 'Special Offer',
  startDate: 'Start Date',
  location: 'Location',
  instructor: 'Instructor',
  moneyBackGuarantee: 'Money Back Guarantee',
  limitedSeats: 'Limited Seats',
  needHelp: 'Need Help?',
  whatsappUs: 'WhatsApp Us',
  callUs: 'Call Us',

  // Actions
  enrollNow: 'Enroll Now',
  downloadBrochure: 'Download Brochure',
  brochureDownloading: 'Downloading brochure...',
  loading: 'Loading...',

  // Common
  home: 'Home',
  courses: 'Courses',
  contactUs: 'Contact Us',
  chineseLearning: 'Chinese Learning',
  siteTitle: 'SAI Academic College',
  students: 'students',

  // Course Badges
  badges: {
    hsk: 'HSK',
    diploma: 'Diploma',
    scholarship: 'Scholarship',
    certified: 'Certified',
    online: 'Online',
    offline: 'In-Person',
    hybrid: 'Hybrid'
  },

  // Module/Lesson Terms
  module: 'Module',
  lesson: 'Lesson',
  modules: 'Modules',

  // Time Units
  weeks: 'weeks',
  months: 'months',
  hours: 'hours',

  // Course Info Labels
  enrolled: 'enrolled',
  rating: 'rating',
  reviews: 'reviews',

  // SEO Templates for Individual Courses
  courseSeoTitle: '{courseName} - SAI Academic College | Confucius Institute',
  courseSeoDescription: 'Learn {courseName} with expert instructors at SAI Academic College. Comprehensive {level} course with certified credentials. Enroll now!',
  courseSeoKeywords: '{courseName}, learn Chinese, HSK, Confucius Institute, Chinese language courses, SAI Academic, Sana\'a, Yemen',

  // Enrollment Form
  enrollment: {
    title: 'Course Enrollment',
    courseLabel: 'Selected Course',
    fullName: 'Full Name',
    fullNamePlaceholder: 'Enter your full name',
    email: 'Email Address',
    emailPlaceholder: 'example@email.com',
    phone: 'Phone Number',
    phonePlaceholder: '+967 777 123 456',
    studyMode: 'Preferred Study Mode',
    studyModePlaceholder: 'Select study mode',
    studyModes: {
      online: 'Online',
      offline: 'In-Person',
      hybrid: 'Hybrid (Online + In-Person)'
    },
    preferredStartDate: 'Preferred Start Date',
    chineseLevel: 'Current Chinese Level',
    chineseLevelPlaceholder: 'Select your current level',
    levels: {
      none: 'No prior experience',
      beginner: 'Beginner (some words)',
      hsk1: 'HSK 1',
      hsk2: 'HSK 2',
      hsk3: 'HSK 3',
      hsk4: 'HSK 4',
      hsk5: 'HSK 5',
      hsk6: 'HSK 6'
    },
    message: 'Additional Notes',
    messagePlaceholder: 'Any additional information you would like to share with us...',
    privacyNote: 'Your information is protected and will not be shared with any third party. Our team will contact you within 24 hours.',
    submit: 'Submit Enrollment Request',
    submitting: 'Submitting...',
    cancel: 'Cancel',
    close: 'Close',
    successTitle: 'Request Submitted Successfully! 🎉',
    successMessage: 'Thank you for your interest in enrolling in this course. Our team will contact you within 24 hours to confirm your enrollment and guide you through the next steps.',
    errors: {
      fullNameRequired: 'Full name is required',
      emailRequired: 'Email address is required',
      emailInvalid: 'Invalid email format',
      phoneRequired: 'Phone number is required',
      phoneInvalid: 'Invalid phone number format',
      studyModeRequired: 'Please select a study mode',
      startDateRequired: 'Please select a start date',
      chineseLevelRequired: 'Please select your current level'
    }
  },

  // YCT Program Page
  yct: {
    hero: {
      title: 'Youth Chinese Test (YCT) Program',
      subtitle: 'A Fun Journey to Learn Chinese for Kids and Teens',
      description: 'The Youth Chinese Test (YCT) is an international standardized Chinese proficiency test designed specifically for young learners aged 6 to 15 years old.',
      enrollButton: 'Enroll Your Child Now',
      learnMoreButton: 'Learn More'
    },
    whatIsYCT: {
      title: 'What is YCT?',
      description: 'The Youth Chinese Test (YCT) is an international standardized Chinese proficiency test. It assesses young students\' ability to use Chinese in their daily and academic lives.',
      levels: {
        title: 'YCT Levels',
        level1: {
          name: 'YCT Level 1',
          description: '80 words - Perfect for beginners who are just starting their Chinese learning journey',
          vocabulary: '80 words'
        },
        level2: {
          name: 'YCT Level 2',
          description: '150 words - Building a strong foundation with essential vocabulary and phrases',
          vocabulary: '150 words'
        },
        level3: {
          name: 'YCT Level 3',
          description: '300 words - Expanding language skills for everyday conversations',
          vocabulary: '300 words'
        },
        level4: {
          name: 'YCT Level 4',
          description: '600 words - Mastering Chinese for confident communication',
          vocabulary: '600 words'
        }
      }
    },
    benefits: {
      title: 'Why Choose Our YCT Program?',
      benefit1: {
        title: 'Fun & Interactive Learning',
        description: 'Engaging lessons with games, activities, and multimedia designed for young learners'
      },
      benefit2: {
        title: 'Internationally Recognized Certificate',
        description: 'Earn an official YCT certificate recognized worldwide'
      },
      benefit3: {
        title: 'Age-Appropriate',
        description: 'Curriculum specifically designed for children\'s cognitive development stages'
      },
      benefit4: {
        title: 'Expert Instructors',
        description: 'Experienced teachers specialized in teaching Chinese to children'
      },
      benefit5: {
        title: 'Small Class Sizes',
        description: 'Personal attention with small class sizes for optimal results'
      },
      benefit6: {
        title: 'Flexible Schedules',
        description: 'Online and in-person study options to fit your family\'s schedule'
      }
    },
    ageGroups: {
      title: 'Target Age Groups',
      group1: {
        age: '6-12 Years',
        title: 'Young Children',
        description: 'Perfect for elementary school children starting their Chinese learning journey',
        levels: 'YCT Level 1-3'
      },
      group2: {
        age: '13-15 Years',
        title: 'Young Teens',
        description: 'Designed for middle school students who want to deepen their Chinese skills',
        levels: 'YCT Level 3-4'
      }
    },
    curriculum: {
      title: 'Curriculum Overview',
      description: 'Our YCT program follows a structured curriculum that builds language skills progressively',
      level1: {
        title: 'YCT Level 1',
        topics: [
          'Basic greetings and introductions',
          'Numbers and colors',
          'Family members',
          'Common animals and food',
          'Simple daily activities'
        ]
      },
      level2: {
        title: 'YCT Level 2',
        topics: [
          'Time and dates',
          'Weather and seasons',
          'Hobbies and interests',
          'School life',
          'Shopping and prices'
        ]
      },
      level3: {
        title: 'YCT Level 3',
        topics: [
          'Describing people and places',
          'Expressing preferences',
          'Talking about past experiences',
          'Making suggestions',
          'Understanding simple texts'
        ]
      },
      level4: {
        title: 'YCT Level 4',
        topics: [
          'Complex conversations',
          'Expressing opinions',
          'Understanding Chinese culture',
          'Advanced reading and writing',
          'Preparation for HSK'
        ]
      }
    },
    instructor: {
      title: 'Meet Your Instructor',
      name: 'Li Xiaomei',
      role: 'Lead YCT Instructor',
      bio: 'With over 10 years of experience teaching Chinese to children, Teacher Li specializes in making language learning fun and engaging. She holds a degree in Teaching Chinese as a Foreign Language and is passionate about helping young students discover the beauty of Chinese language and culture.',
      qualifications: [
        'Master\'s in Teaching Chinese as a Foreign Language',
        'YCT Teaching Certification',
        '10+ years teaching experience',
        'Specialized in children\'s education'
      ]
    },
    testimonials: {
      title: 'What Parents Say',
      testimonial1: {
        text: 'My daughter loves the YCT classes! Teacher Li makes learning so much fun, and her Chinese has improved dramatically in just a few months.',
        parent: 'Sarah Ahmed',
        relation: 'Parent of YCT Level 2 Student'
      },
      testimonial2: {
        text: 'Excellent program for kids! The curriculum is well-designed, and the teachers are patient and professional. My son looks forward to every lesson.',
        parent: 'Mohammed Ali',
        relation: 'Parent of YCT Level 3 Student'
      },
      testimonial3: {
        text: 'Best investment in my daughter\'s education. She passed the YCT Level 1 exam with excellent scores and is now confident speaking Chinese.',
        parent: 'Fatima Hassan',
        relation: 'Parent of YCT Level 1 Student'
      }
    },
    faq: {
      title: 'Frequently Asked Questions',
      question1: {
        q: 'What is the right age to start the YCT program?',
        a: 'The YCT program is designed for children aged 6 to 15 years old. We recommend starting with YCT Level 1 for children aged 6-8 with no prior Chinese experience.'
      },
      question2: {
        q: 'How often are classes held?',
        a: 'We offer flexible scheduling options. Typically, we recommend 2-3 classes per week, with each class lasting 60 minutes, for optimal results.'
      },
      question3: {
        q: 'Does my child need any prior experience?',
        a: 'No, YCT Level 1 is designed for complete beginners. Your child will start from the basics and progress gradually.'
      },
      question4: {
        q: 'What materials are required?',
        a: 'We provide all learning materials including textbooks, worksheets, and online resources. You\'ll only need a notebook and pens for homework.'
      },
      question5: {
        q: 'When can my child take the YCT exam?',
        a: 'Official YCT exams are held several times a year. We\'ll recommend an exam date when your child is ready based on their progress.'
      },
      question6: {
        q: 'Do you offer online classes?',
        a: 'Yes! We offer both in-person and online classes. Our online classes are just as interactive and engaging as in-person lessons.'
      }
    },
    cta: {
      title: 'Ready to Start Your Child\'s Chinese Learning Journey?',
      description: 'Join our YCT program today and give your child the gift of language mastery and cultural awareness',
      enrollButton: 'Enroll Now',
      contactButton: 'Contact Us'
    }
  }
};

// Export the object as the default export (single export)
export default courses;
